import { useRouter } from 'next/router';

const ACCEPTED_HOST_APPS = ['ios', 'android'];
const ACCEPTED_FROM_APPS = ['ipad', 'iphone', 'android'];

export function useIsInMobileWebView(): boolean {
  const router = useRouter();
  const { fromApp, hostApp } = router.query as {
    fromApp?: string;
    hostApp?: string;
  };

  return Boolean(
    (hostApp && ACCEPTED_HOST_APPS.includes(hostApp)) || (fromApp && ACCEPTED_FROM_APPS.includes(fromApp)),
  );
}
